import React, { Component } from 'react';
import BigCalendar from 'react-big-calendar';
import { observer } from 'mobx-react'
import Doc2HdeptStore from '../stores/Doc2HdeptStore';
import moment from 'moment';
import queryString from 'query-string'
// import mobx from 'mobx';
import * as mobx from 'mobx'
import FontAwesome from 'react-fontawesome'
import '../index.css';
import _ from 'lodash'
import ReactTooltip from 'react-tooltip'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Loop from 'material-ui/svg-icons/av/loop';
import { withRouter } from "react-router-dom";
import urlParam from '../urlParam';
import Dialog from './Dialog';
import DialogStore from '../stores/DialogStore';

moment.locale('zh-tw');
BigCalendar.momentLocalizer(moment);

function renderEvents() {
  if (Doc2HdeptStore.isReady) {
    // console.log('view發現讀取完畢！')
    return mobx.toJS(Doc2HdeptStore.events)
  } else {
    // console.log('view發現還在忙')
    return [];
  }
}

function Event({ event }) {
  if (Doc2HdeptStore.doctor !== '') {
    //已指定醫生，event顯示上下午診。
    return (
      <div className="eventStyle" title='' style={{ textAlign: 'center', fontSize: '11px' }} data-tip={`${event.area}`} >
        {event.title}<ReactTooltip />
      </div>
    )
  } else {
    //指定科別，event顯示各種醫生+超連結。
    let parsed = {};
    parsed.hdept = '';
    parsed.team = '';

    parsed.docno = event.doc_no;
    parsed.date = Doc2HdeptStore.year_selected + Doc2HdeptStore.month_selected;
    const stringified = queryString.stringify(parsed);

    return (
      <div style={{ textAlign: 'center', fontSize: '11px' }} >
        <a className="eventStyle" href={"?" + stringified} >{event.title}</a>
      </div>
    )
  }
}

const MyToolbar = (toolbar) => {
  const goToBack = () => {
    toolbar.date.setMonth(toolbar.date.getMonth() - 1);
    toolbar.onNavigate('prev');
  };

  const goToNext = () => {
    toolbar.date.setMonth(toolbar.date.getMonth() + 1);
    toolbar.onNavigate('next');
  };

  const label = () => {
    const date = moment(toolbar.date);
    if (Doc2HdeptStore.hdept_ch_name || Doc2HdeptStore.doctor_ch_name) {
      return (
        <span>{date.format('YYYY')}{date.format('MMMM')}({Doc2HdeptStore.hdept_ch_name}{Doc2HdeptStore.doctor_ch_name})</span>
      )
    }
    return (
      <span>{date.format('YYYY')}年{date.format('MM')}月 <span style={{ color: 'orange' }}>{Doc2HdeptStore.message}</span></span>
    );
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      paddingLeft: '15px',
      paddingRight: '15px',
      paddingBottom: '8px',
      alignItems: 'center',
      zIndex: '1',
      background: 'linear-gradient(#EAEBED,#DDDEE2)'
    }}>
      <div onClick={goToBack}>
        <FontAwesome
          name='angle-left'
          size='2x'
          style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)', cursor: 'pointer' }}
        />
      </div>
      <label style={{ fontSize: 'larger' }}>{label()}</label>
      <div onClick={goToNext}>
        <FontAwesome
          name='angle-right'
          size='2x'
          style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)', cursor: 'pointer' }}
        />
      </div>
    </div>
  );
};

// let formats = {
//   dateFormat: 'DD'
// }

export default withRouter(observer(class Calendar extends Component {
  eventStyleGetter(event, start, end) {
    var style = {
      backgroundColor: '#ACDAFF',
      border: '1px',
      borderStyle: 'solid',
      display: 'flex',
      justifyContent: 'center',
      padding: '5px 0 5px 0',
      borderRadius: '3px',
    };

    if (_.includes(event.title, '教學')) {
      style.backgroundColor = '#89D951';
    } else if (_.includes(event.title, '下午')) {
      style.backgroundColor = '#F4DBD8';
    }

    if (window.innerWidth < 350) {
      style.padding = '0px 0px'
    } else if (window.innerWidth < 420) {
      style.padding = '2px 0px'
    }

    return {
      style: style,
      className: "aaaaaaaaa"
    };
  }

  showDialog = () => {
    DialogStore.showDialog()
  }

  render() {
    return (
      <div>
        <BigCalendar
          events={renderEvents()}
          components={{
            event: Event,
            toolbar: MyToolbar
          }}
          /*date={Doc2HdeptStore.date}*/
          defaultDate={moment().toDate()}
          views={['month']}
          selectable={true}
          popup={true}
          style={{ width: '100%', height: '100%', position: 'absolute' }}
          // style={{ flex: '1' }}
          eventPropGetter={this.eventStyleGetter}
        // formats={formats}
        />
        {
          urlParam.app === 'true'
            ? <FloatingActionButton onClick={() => this.showDialog()} mini={true} style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
              <Loop />
            </FloatingActionButton>
            : null
        }
        <Dialog goTitle='依科別找醫師' goUrl='/hdept2doc' />
      </div>
    )
  }
}))


// WEBPACK FOOTER //
// ./src/components/D2HCalendar.js